import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Namespaces de traducción (es/en)
import esCommon from './locales/es/common.json'
import enCommon from './locales/en/common.json'
import esNav from './locales/es/nav.json'
import enNav from './locales/en/nav.json'
import esDashboard from './locales/es/dashboard.json'
import enDashboard from './locales/en/dashboard.json'
import esProfile from './locales/es/profile.json'
import enProfile from './locales/en/profile.json'
import esProperties from './locales/es/properties.json'
import enProperties from './locales/en/properties.json'
import esBilling from './locales/es/billing.json'
import enBilling from './locales/en/billing.json'
import esSettings from './locales/es/settings.json'
import enSettings from './locales/en/settings.json'
import esAuth from './locales/es/auth.json'
import enAuth from './locales/en/auth.json'
import esCrm from './locales/es/crm.json'
import enCrm from './locales/en/crm.json'

// Clave en localStorage donde se guarda el idioma elegido por el usuario.
// NOTA: independiente de 'innovagent_region' (RegionContext). Idioma y región
// son conceptos separados pero coordinados (Opción A).
export const LANGUAGE_STORAGE_KEY = 'innovagent_language'

// Idiomas soportados. Ampliar aquí al agregar nuevos.
export const SUPPORTED_LANGUAGES = ['es', 'en'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]
export const DEFAULT_LANGUAGE: SupportedLanguage = 'es'


// Nombre nativo de cada idioma (endónimo) para mostrar en la UI.
// Al agregar un idioma: añadir su código a SUPPORTED_LANGUAGES,
// su nombre aquí, y crear locales/<código>/common.json
export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  es: 'Español',
  en: 'English'
}

const resources = {
  es: { common: esCommon, nav: esNav, dashboard: esDashboard, profile: esProfile, properties: esProperties, billing: esBilling, settings: esSettings, auth: esAuth, crm: esCrm },
  en: { common: enCommon, nav: enNav, dashboard: enDashboard, profile: enProfile, properties: enProperties, billing: enBilling, settings: enSettings, auth: enAuth, crm: enCrm }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: 'common',
    ns: ['common', 'nav', 'dashboard', 'profile', 'properties', 'billing', 'settings', 'auth', 'crm'],
    detection: {
      // Orden: 1) elección previa del usuario (localStorage)
      //        2) idioma del navegador
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false // React ya escapa por defecto (anti-XSS)
    },

    // Solo idioma base: 'es-MX' o 'en-US' colapsan a 'es' / 'en'
    load: 'languageOnly'
  })

export default i18n
